import { Link } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";
import ABAudioPlayer from "../components/ABAudioPlayer";

/* TODO: Bu geçici placeholder görseller, kullanıcı kendi orijinal stüdyo/portfolyo fotoğraflarını
   ilettiğinde değiştirilecektir. Masaüstünde yatay (16:9), mobilde dikey (9:16) sürüm kullanılır. */
const HERO_DESKTOP = "https://images.unsplash.com/photo-1518972559570-7cc1309f3229?w=1920&h=1080&fit=crop&crop=entropy&auto=format&q=80";
const HERO_MOBILE = "https://images.unsplash.com/photo-1574517947730-55cb23e608c2?w=900&h=1600&fit=crop&crop=entropy&auto=format&q=80";
const PRICING_BG = "https://images.pexels.com/photos/9875243/pexels-photo-9875243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920";

// A/B karşılaştırma örnek trackleri — sırayla: Rock, Pop, Akustik
// (Rap şimdilik kaldırıldı, ileride tekrar eklenebilir)
const AB_TRACKS = [
  {
    key: "rock",
    title: "Rock",
    artist: "Mix vs. Bypass",
    beforePath: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mix-master-service/artifacts/jsxrus2h_Rock%20-%20Bypass%20Mix%20.wav",
    afterPath: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mix-master-service/artifacts/qll0lj4g_Rock%20-%20Mix%20.wav",
  },
  {
    key: "pop",
    title: "Pop",
    artist: "Mix vs. Bypass",
    beforePath: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mix-master-service/artifacts/09bc28nm_Pop%20Bypass.wav",
    afterPath: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mix-master-service/artifacts/ibvi9r0z_Pop%20Mix%20.wav",
  },
  {
    key: "acoustic",
    title: "Akustik",
    artist: "Mix vs. Bypass",
    beforePath: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mix-master-service/artifacts/4fwu2v82_Acoustic%20-%20Bypass.wav",
    afterPath: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mix-master-service/artifacts/m123asbe_Acoustic%20-%20Mix%20.wav",
  },
];

export default function Home() {
  return (
    <main data-testid="home-page">
      {/* HERO — embedded background, responsive (horizontal on md+, vertical on mobile) */}
      <section
        className="relative overflow-hidden min-h-[88vh] md:min-h-[92vh] flex items-center"
        data-testid="hero-section"
      >
        {/* TODO: Placeholder arka plan görselleri; kullanıcı kendi stüdyo fotoğraflarını iletince değiştirilecek. */}
        <div className="absolute inset-0 z-0" aria-hidden="true">
          <picture>
            <source media="(min-width: 768px)" srcSet={HERO_DESKTOP} />
            <img
              src={HERO_MOBILE}
              alt=""
              loading="lazy"
              className="w-full h-full object-cover object-center md:bg-fixed"
            />
          </picture>
          {/* Okunabilirlik için kademeli gradient overlay + hafif blur */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10] via-[#0B0C10]/75 to-[#0B0C10]/30" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B0C10]/95 via-[#0B0C10]/60 to-transparent md:from-[#0B0C10]/90 md:via-[#0B0C10]/40" />
          <div className="absolute inset-0 vu-grid opacity-25 mix-blend-overlay" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-24 md:py-32 w-full">
          <div className="max-w-3xl fade-up">
            <div className="mono-caps mb-4">Analog Hibrit Mix & Master · İstanbul</div>
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold tracking-tight text-white leading-[1.02]"
                style={{ textShadow: "0 2px 24px rgba(0,0,0,0.55)" }}>
              Ham kayıtlarınızı<br />
              <span className="gradient-text">radyoya hazır</span> yayın kalitesine taşıyoruz.
            </h1>
            <p className="mt-6 text-slate-200 text-lg max-w-2xl leading-relaxed"
               style={{ textShadow: "0 1px 12px rgba(0,0,0,0.6)" }}>
              20 kanaldan 40+ kanala kadar profesyonel mix ve mastering hizmeti. Konsol, outboard komprösör
              ve analog EQ zincirinden geçen sesler, saf ve karakterli çıktıya dönüşür. 2 revizyon dahil.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/siparis" className="btn-cyan inline-flex items-center gap-2" data-testid="hero-order-cta">
                Sipariş Ver <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/" onClick={(e) => {
                e.preventDefault();
                document.getElementById("home-ab-section")?.scrollIntoView({ behavior: "smooth" });
              }} className="btn-ghost inline-flex items-center gap-2 backdrop-blur-sm bg-black/20"
                    data-testid="hero-portfolio-cta">
                <Play className="w-4 h-4" /> Örnekleri Dinle
              </Link>
            </div>
            <div className="mt-10 grid grid-cols-3 max-w-lg gap-6">
              <Stat n="5M+" l="Toplam Stream" />
              <Stat n="100+" l="Tamamlanan Prodüksiyon" />
              <Stat n="10+" l="Yıl Stüdyo Tecrübesi" />
            </div>
          </div>
        </div>
      </section>

      {/* A/B COMPARISON — hero (stats) altında, fiyatlandırmanın üstünde */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16" id="home-ab-section" data-testid="home-ab-section">
        <div className="mono-caps mb-3">Öncesi / Sonrası</div>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white">
          Aynı kayıt, iki farklı dünya. <span className="gradient-text">Sen karar ver.</span>
        </h2>
        <p className="mt-3 text-slate-400 max-w-2xl">
          Her tür için mix öncesi (bypass) ve mix sonrası halini karşılaştır. Üstteki A/B düğmesiyle
          anında geçiş yapabilirsin.
        </p>
        <div className="grid md:grid-cols-2 gap-6 mt-8">
          {AB_TRACKS.map((t) => (
            <ABAudioPlayer
              key={t.key}
              title={t.title}
              artist={t.artist}
              beforePath={t.beforePath}
              afterPath={t.afterPath}
            />
          ))}
        </div>
      </section>

      {/* PRICING PREVIEW — subtle embedded studio backdrop (responsive) */}
      <section className="relative overflow-hidden" data-testid="pricing-section">
        {/* TODO: Bu geçici placeholder görsel, kullanıcı kendi orijinal stüdyo/portfolyo fotoğraflarını
            ilettiğinde değiştirilecektir. */}
        <div className="absolute inset-0 z-0" aria-hidden="true">
          <img
            src={PRICING_BG}
            alt=""
            loading="lazy"
            className="w-full h-full object-cover object-center opacity-30 md:opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B0C10] via-[#0B0C10]/85 to-[#0B0C10]" />
          <div className="absolute inset-0 backdrop-blur-[2px]" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20">
          <div className="flex items-end justify-between mb-8">
            <div>
              <div className="mono-caps mb-2">Fiyatlandırma</div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white"
                  style={{ textShadow: "0 2px 16px rgba(0,0,0,0.55)" }}>
                Şeffaf paket ücretleri
              </h2>
            </div>
            <Link to="/siparis" className="btn-ghost hidden md:inline-flex items-center gap-2 backdrop-blur-sm bg-black/25"
                  data-testid="pricing-order-link">
              Sipariş oluştur <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        <div className="grid md:grid-cols-3 gap-6" data-testid="home-ab-section-anchor">
          <div id="home-ab-section-anchor" className="hidden" />
          {[
              { name: "20 Kanala Kadar", price: "8.000", tag: "1 – 20 stem", active: false },
              { name: "40 Kanala Kadar", price: "12.000", tag: "21 – 40 stem", active: true },
              { name: "40+ Kanal", price: "15.000", tag: "Sınırsız stem", active: false },
            ].map((p, i) => (
              <div
                key={i}
                className={`panel p-6 md:p-8 relative backdrop-blur-md flex flex-col ${p.active ? "glow-cyan" : ""}`}
                style={{ background: "linear-gradient(180deg, rgba(24,27,38,0.85), rgba(18,20,28,0.9))" }}
                data-testid={`pricing-card-${i}`}
              >
                {p.active && <div className="absolute -top-3 left-6 bg-cyan-400 text-black text-[11px] font-mono uppercase tracking-widest font-semibold px-3 py-1 rounded-full shadow-lg">Popüler</div>}
                <div className="text-slate-300 text-sm">{p.tag}</div>
                <div className="font-display text-2xl mt-1 text-white">{p.name}</div>
                <div className="mt-6 flex items-baseline gap-2">
                  <span className="font-display text-5xl font-bold text-white">{p.price}</span>
                  <span className="text-slate-400">₺</span>
                </div>
                <ul className="text-sm text-slate-300 mt-6 space-y-2 flex-1">
                  <li>• Analog hibrit mix zinciri</li>
                  <li>• 2 ücretsiz revizyon</li>
                  <li>• Mastering ekleme: +5.000 ₺</li>
                </ul>
                <Link
                  to="/siparis"
                  data-testid={`pricing-order-btn-${i}`}
                  className={`mt-6 inline-flex items-center justify-center gap-2 w-full ${p.active ? "btn-cyan" : "btn-ghost"}`}
                >
                  Sipariş Ver <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            ))}
        </div>
        </div>
      </section>
    </main>
  );
}

function Stat({ n, l }) {
  return (
    <div>
      <div className="font-display text-3xl font-bold text-white" style={{ textShadow: "0 1px 8px rgba(0,0,0,0.6)" }}>{n}</div>
      <div className="mono-caps mt-1 text-slate-300">{l}</div>
    </div>
  );
}
